import { classNames } from "../../../../helpers/classNames";
import { planListFront } from "../../../../services/plansService";
import useFetch from "../../../../hooks/useFetch";
import Button from "../../../forms/Button";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const Pricing = () => {
  const { data: plans } = useFetch({
    dependencies: ["planListFront"],
    fetchFunction: async () => {
      const res = await planListFront();
      if (res?.docs?.status === 200) {
        return res?.docs?.data || [];
      }
      return [];
    },
  });

  const navigate = useNavigate();
  const { session } = useSelector((state) => state?.authProvider);
  const userId = session?.user?._id;
  const role = session?.user?.role;

  const handleSelectPlan = (plan) => {
    localStorage.setItem("selectedPlan", JSON.stringify(plan));
    window.dispatchEvent(new Event("cartUpdated"));

    if (!userId || role !== "user") {
      navigate(`/signin?selectedPlanId=${plan._id}`);
    } else {
      navigate(`/dashboard?selectedPlanId=${plan._id}`);
    }
  };

  return (
    <section className="relative py-16 overflow-hidden bg-md-pink-light-2 min-h-[calc(100vh-20rem)]">
      <div className="relative w-full px-4 sm:px-0 sm:max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-6xl 2xl:max-w-7xl 3xl:max-w-8xl mx-auto">
        <div className="space-y-8 sm:space-y-16">
          <div className="space-y-6 text-center">
            <h2 className="text-4xl xl:text-5xl 3xl:text-6xl font-semibold tracking-tight">Pricing Plans</h2>
            <div className="text-lg lg:text-xl xl:text-2xl 3xl:text-3xl tracking-wide text-neutral-500 max-w-xl lg:max-w-3xl 3xl:max-w-5xl mx-auto leading-snug">Choose the perfect plan that fits your needs. All plans offer high-quality printing and beautiful results.</div>
          </div>
          {plans?.length > 0 && (
            <div className="grid">
              <div className="flex sm:grid grid-cols-3 gap-4 xl:gap-8 3xl:gap-10 overflow-x-auto sm:overflow-visible -mx-4 sm:mx-0 px-4 sm:px-0 py-5 sm:py-0 scrollbar-none snap-x sm:snap-none">
                {plans?.map((item, itemindex) => (
                  <div
                    key={itemindex}
                    className={classNames(
                      "snap-center sm:snap-none relative min-w-72 sm:min-w-0 bg-white border rounded-3xl py-8 lg:py-12 px-6 sm:px-4 lg:px-6 flex flex-col transition-all duration-300 hover:shadow-xl hover:shadow-md-pink/30",
                      item?.highLightTag === 1 ? "border-md-pink ring-4 ring-md-pink" : "border-md-pink-light-3"
                    )}
                  >
                    {item?.highLightTag === 1 && (
                      <div className="absolute h-8 rounded-full px-6 bg-md-pink inline-flex items-center text-sm xl:text-base justify-center text-white font-medium xl:pb-1 top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 -mt-0.5 tracking-wider whitespace-nowrap">{item?.highLightText || "Most Popular"}</div>
                    )}
                    <div className="space-y-6 lg:space-y-10 mb-6 lg:mb-10 w-full max-w-72 3xl:max-w-xs mx-auto">
                      <div className="text-center space-y-4">
                        <div className="text-xl lg:text-2xl xl:text-3xl text-md-dark font-medium">{item?.name}</div>
                        {typeof item?.planPricingData?.price === "number" &&
                          (() => {
                            const price = item?.planPricingData?.price.toFixed(2);
                            const [integer, fraction] = price.split(".");
                            return (
                              <div className="text-neutral-500 text-lg lg:text-xl xl:text-2xl inline-flex items-end gap-2">
                                <span className="text-4xl lg:text-5xl xl:text-6xl font-bold text-md-pink tracking-tight">
                                  {"$" + integer}
                                  <sup className="text-xl lg:text-2xl xl:text-3xl font-medium">{"." + fraction}</sup>
                                </span>
                                <span>/ book</span>
                              </div>
                            );
                          })()}
                      </div>
                      <div className="relative flex-shrink-0">
                        {item?.features?.length > 0 && (
                          <div className="space-y-2 lg:space-y-4">
                            {item?.features?.map((featureitem, featureindex) => (
                              <div key={featureindex} className="flex items-start text-base lg:text-lg xl:text-xl 3xl:text-2xl text-neutral-500 gap-2 xl:gap-4">
                                <span className="text-xl xl:text-2xl 3xl:text-3xl text-md-pink">
                                  <i className="fa-light fa-fw fa-check"></i>
                                </span>
                                <span>{featureitem?.name}</span>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="mt-auto flex justify-center w-full max-w-72 3xl:max-w-xs mx-auto">
                      <Button
                        buttonHasLink={false}
                        buttonLabel={item?.planPricingData?.priceDescription}
                        buttonFunction={() => handleSelectPlan(item)}
                        buttonClasses={classNames("w-full !h-12 xl:!h-14 3xl:!h-16 !px-4 xl:!px-12 hover:shadow-lg hover:shadow-md-pink/50 pb-0.5 3xl:pb-1", item?.highLightTag === 1 ? "" : "bg-md-pink-light-1 !text-md-pink !font-medium hover:!text-white")}
                        buttonLabelClasses={classNames("!text-base !font-semibold lg:!font-medium lg:!text-lg xl:!text-xl 3xl:!text-2xl", item?.highLightTag === 1 ? "" : "")}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Pricing;
